module.exports = __webpack_public_path__ + "img/4383478.5df56182.jpg";